export const buildInboxSettingsTabs = ({
  labels,
  isAVoiceChannel = false,
  isAWebWidgetInbox = false,
  isATwilioChannel = false,
  isALineChannel = false,
  isAPIInbox = false,
  isAnEmailChannel = false,
  isEvolutionWhatsAppChannel = false,
  shouldShowWhatsAppConfiguration = false,
  isAgentBotsEnabled = false,
  isAWhatsAppCloudChannel = false,
}) => {
  let tabs = [
    {
      key: 'inbox-settings',
      name: labels.settings,
    },
    {
      key: 'collaborators',
      name: labels.collaborators,
    },
  ];

  if (!isAVoiceChannel) {
    tabs = [
      ...tabs,
      {
        key: 'business-hours',
        name: labels.businessHours,
      },
      {
        key: 'csat',
        name: labels.csat,
      },
    ];
  }

  if (isAWebWidgetInbox) {
    tabs = [
      ...tabs,
      {
        key: 'pre-chat-form',
        name: labels.preChatForm,
      },
    ];
  }

  if (
    isATwilioChannel ||
    isALineChannel ||
    isAPIInbox ||
    isAVoiceChannel ||
    isAnEmailChannel ||
    (shouldShowWhatsAppConfiguration && !isEvolutionWhatsAppChannel) ||
    isAWebWidgetInbox
  ) {
    tabs = [
      ...tabs,
      {
        key: 'configuration',
        name: labels.configuration,
      },
    ];
  }

  if (isAgentBotsEnabled) {
    tabs = [
      ...tabs,
      {
        key: 'bot-configuration',
        name: labels.botConfiguration,
      },
    ];
  }

  if (isAWhatsAppCloudChannel) {
    tabs = [
      ...tabs,
      {
        key: 'whatsapp-health',
        name: labels.accountHealth,
      },
    ];
  }

  return tabs;
};

export const shouldShowEvolutionConnectionOnSettingsTab = ({
  isEvolutionWhatsAppChannel,
  selectedTabKey,
}) => isEvolutionWhatsAppChannel && selectedTabKey === 'inbox-settings';
